// extracted by mini-css-extract-plugin
module.exports = {"rates":"Rates_rates__1gMI5","star":"Rates_star__36CHM","ratedStar":"Rates_ratedStar__2XBRA Rates_star__36CHM","rateText":"Rates_rateText__XhZnu"};